export enum DocTopic {
    // Note, that these constants are defined by the existing CDocTopicsConst.java file.
    INTRODUCTION = 'Introduction',
    SIGNINGIN = 'SigningIn',
    CMD_INSIGHTS_HUB = 'InsightsHub',
    CMD_INSIGHTS_HUB_V2 = 'InsightsHubV2',
    MOBILEAPPS = 'MobileApplications',
    PASSWORDCHG = 'PasswordChg',
    PASSWORDRESET = 'PasswordReset',
    REPORTING = 'Reporting',
    RPTGOVERVIEW = 'RptgOverview',
    RPTGRUNNING = 'RptgRunning',
    RPTGFOLDERS = 'RptgFolders',
    RPTGREFRESHING = 'RptgRefreshing',
    RPTGEXPORTING = 'RptgExporting',
    RPTGPRINTING = 'RptgPrinting',
    RPTGSNAPSHOTTING = 'RptgSnapshotting',
    RPTGQUICKFILTERDATETIME = 'RptgQuickFilterDateTime',
    RPTGQUICKFILTERDEVICE = 'RptgQuickFilterDevice',
    RPTGQUICKWBTILETYPE = 'RptgQuickWBTileType',
    RPTGQUICKVIEWTYPE = 'RptgQuickViewType',
    RPTGSCHEDULED = 'RptgScheduled',
    RPTGTABSORDERING = 'RptgTabsOrdering',
    RPTGTRANSITIONING = 'RptgTransitioning',
    RPTGCHARTING = 'RptgCharting',
    RPTGADDING = 'RptgAdding',
    RPTGCHANGING = 'RptgChanging',
    RPTGDELETING = 'RptgDeleting',
    RPTGADDINGDEFAULTREPORTS = 'RptgAddingDefaultReports',
    RPTGRPTPROPS = 'RptgRptProps',
    RPTGRPTPROPSRPTTAB = 'RptgRptPropsRptTab',
    RPTGRPTPROPSDATETIMETAB = 'RptgRptPropsDateTimeTab',
    RPTGRPTPROPSFIELDSTAB = 'RptgRptPropsFieldsTab',
    RPTGRPTPROPSSLAKPITAB = 'RptgRptPropsSlaKpiTab',
    RPTGRPTPROPSDASHBOARDTAB = 'RptgRptPropsDashboardTab',
    RPTGRPTPROPSFILTERTAB = 'RptgRptPropsFilterTab',
    RPTGRPTPROPSOTHERTAB = 'RptgRptPropsOtherTab',
    RPTGRPTPROPSSCHEDULESETTINGSTAB = 'RptgRptPropsScheduleSettingsTab',
    RPTGRPTPROPSALARMSTAB = 'RptgRptPropsAlarmsTab',
    RPTGRPTPROPSSCHEDULESTATUSTAB = 'RptgRptPropsScheduleStatusTab',
    RPTGRPTPROPSTRANSITIONINGTAB = 'RptgRptPropsTransitioningTab',
    RPTGRPTPROPSACDCODESTAB = 'RptgRptPropsACDCodesTab',
    RPTGRPTPROPSFINANCIALTAB = 'RptgRptPropsFinancialTab',
    RPTGRPTPROPSSETTINGSTAB = 'RptgRptPropsSettingsTab',
    RPTGRPTPROPSADVANCEDTAB = 'RptgRptPropsAdvancedTab',
    RPTGRPTPROPSPRINTTAB = 'RptgRptPropsPrintTab',
    RPTGCALLCTRL = 'RptgCallCtrl',
    RPTGCALLCTRLUSER = 'RptgCallCtrlUser',
    RPTGCALLCTRLRPT = 'RptgCallCtrlRpt',
    RPTGCALLCTRLTELNODEST = 'RptgCallCtrlTelNoDest',
    RPTGCALLCTRLSETACDSTATUS = 'RptgCallCtrlSetACDStatus',
    RPTGCALLCTRLSIGNINOUT = 'RptgCallCtrlSignInOut',
    RPTGITEMDETAIL = 'RptgItemDetail',
    RPTGITEMDETAILMEETING = 'RptgItemDetailMeeting',
    RPTGRPTSTYLES = 'RptgRptStyles',
    RPTGRPTSTYLESWALLBOARD = 'RptgRptStylesWallboard',
    RPTGRPTSTYLESDASHBOARD = 'RptgRptStylesDashboard',
    RPTGRPTSTYLESACTIVECALLLIST = 'RptgRptStylesActiveCallList',
    RPTGRPTSTYLESHISTORICCALLLIST = 'RptgRptStylesHistoricCallList',
    RPTGRPTSTYLESUNRETURNEDLOSTCALLS = 'RptgRptStylesUnreturnedLostCalls',
    RPTGRPTSTYLESEXTENSIONLIST = 'RptgRptStylesExtensionList',
    RPTGRPTSTYLESACDAGENTLIST = 'RptgRptStylesACDAgentList',
    RPTGRPTSTYLESHUNTGROUPLIST = 'RptgRptStylesHuntGroupList',
    RPTGRPTSTYLESTRUNKLIST = 'RptgRptStylesTrunkList',
    RPTGRPTSTYLESCALLSBYTELNO = 'RptgRptStylesCallsByTelNo',
    RPTGRPTSTYLESCALLSBYDDI = 'RptgRptStylesCallsByDDI',
    RPTGRPTSTYLESTOTALCALLSBYINTERVAL = 'RptgRptStylesTotalCallsByInterval',
    RPTGRPTSTYLESCALLSBYHALFHOURANDDAY = 'RptgRptStylesCallsByHalfHourAndDay',
    RPTGRPTSTYLESCALLSBYINTERVAL = 'RptgRptStylesCallsByInterval',
    RPTGRPTSTYLESCALLSBYDAYOFTHEWEEK = 'RptgRptStylesCallsByDayOfTheWeek',
    RPTGRPTSTYLESCALLSBYACCOUNTCODE = 'RptgRptStylesCallsByAccountCode',
    RPTGRPTSTYLESCALLSBYDNIS = 'RptgRptStylesCallsByDNIS',
    RPTGRPTSTYLESACDACTIVITYLOG = 'RptgRptStylesACDActivityLog',
    RPTGRPTSTYLESCUSTOMREPORT = 'RptgRptStylesCustomReport',
    RPTGCALLMODELLING = 'RptgCallModelling',
    RPTGCALLSCENARIOSPBX = 'RptgCallScenariosPBX',
    RPTGCALLSCENARIOSHOSTED = 'RptgCallScenariosHosted',
    ADMINISTRATION = 'Administration',
    ADMINDEVICES = 'AdminDevices',
    ADMINDEVICESADD = 'AdminDevicesAdd',
    ADMINDEVICESCHG = 'AdminDevicesChg',
    ADMINDEVICESDEL = 'AdminDevicesDel',
    ADMINDEVICESPROPS = 'AdminDevicesProps',
    ADMINACDAGENTS = 'AdminACDAgents',
    ADMINACDAGENTSADD = 'AdminACDAgentsAdd',
    ADMINACDAGENTSCHG = 'AdminACDAgentsChg',
    ADMINACDAGENTSDEL = 'AdminACDAgentsDel',
    ADMINACDAGENTSPROPS = 'AdminACDAgentsProps',
    ADMINCALLRECINT = 'AdminCallRecIntegration',
    ADMINPARTITIONS = 'AdminPartitions',
    ADMINPARTITIONSADD = 'AdminPartitionsAdd',
    ADMINPARTITIONSCHG = 'AdminPartitionsChg',
    ADMINPARTITIONSDEL = 'AdminPartitionsDel',
    ADMINPARTITIONSPROPS = 'AdminPartitionsProps',
    ADMINTELSERVERS = 'AdminTelServers',
    ADMINTELSERVERSADD = 'AdminTelServersAdd',
    ADMINTELSERVERSCHG = 'AdminTelServersChg',
    ADMINTELSERVERSDEL = 'AdminTelServersDel',
    ADMINTELSERVERSPROPS = 'AdminTelServersProps',
    ADMINCMENVIRONMENTS = 'AdminCMEnvironments',
    ADMINCMENVIRONMENTSPROPS = 'AdminCMEnvironmentsProps',
    CME_BRANDING = 'AdminCMEnvironmentsBranding',
    ADMINAPPUSERS = 'AdminAppUsers',
    ADMINAPPUSERSADD = 'AdminAppUsersAdd',
    ADMINAPPUSERSBULK = 'AdminAppUsersBulk',
    ADMINAPPUSERSCHG = 'AdminAppUsersChg',
    ADMINAPPUSERSDEL = 'AdminAppUsersDel',
    ADMINAPPUSERSPROPS = 'AdminAppUsersProps',
    ADMIN_MANAGE_USER_ROLES = 'AdminUserManageRoles',
    ADMINCODES = 'AdminCodes',
    ADMINCODESADD = 'AdminCodesAdd',
    ADMINCODESCHG = 'AdminCodesChg',
    ADMINCODESDEL = 'AdminCodesDel',
    ADMINCODESPROPS = 'AdminCodesProps',
    ADMINDIRECTORUADD = 'AdminDirectoryEntryAdd',
    ADMINOMNICHANNELINTEGRATIONS = 'AdminOmniChannelIntegrations',
    ADMINOMNICHANNELINTEGRATIONSADD = 'AdminOmniChannelIntegrationsAdd',
    ADMINOMNICHANNELINTEGRATIONSCHG = 'AdminOmniChannelIntegrationsChg',
    ADMINOMNICHANNELINTEGRATIONSDEL = 'AdminOmniChannelIntegrationsDel',
    ADMINOMNICHANNELINTEGRATIONSPROPS = 'AdminOmniChannelIntegrationsProps',
    ADMINCALLRECINTEGRATIONS = 'AdminCallRecIntegrations',
    ADMINCALLRECINTEGRATIONSADD = 'AdminCallRecIntegrationsAdd',
    ADMINCALLRECINTEGRATIONSCHG = 'AdminCallRecIntegrationsChg',
    ADMINCALLRECINTEGRATIONSDEL = 'AdminCallRecIntegrationsDel',
    ADMINCALLRECINTEGRATIONSPROPS = 'AdminCallRecIntegrationsProps',
    ADMINDBSETTINGS = 'AdminDbSettings',
    ADMINLOGSETTINGS = 'AdminLogSettings',
    ADMINCLIENTCONFIGURATION = 'CloudConfiguration',
    ADMINCRMCONFIGURATION = 'AdminCRMConfiguration',
    STATUSANDTOOLS = 'StatusAndTools',
    TELMODULESTATUS = 'TelModuleStatus',
    ADMINCALLCTRL = 'AdminCallCtrl',
    LOGFILEMGMT = 'LogFileMgmt',
    SERVERSTATUS = 'ServerStatus',
    SELF_PROVISIONING_WIZARD = 'SelfProvisioningWizard',
    NOTIFICATIONS = 'Notifications',
    MANAGE_ENTERPRISE_USERS = 'ManageEnterpriseUsers',
    MANAGE_QUEUES = 'ManageQueues',
    CMD_TEAMS_PRESENCE = 'TeamsPresence',
    TERMS_AND_CONDITIONS = 'TermsOfService',
    CRM_MODAL = 'CRMModal',
    COOKIE_POLICY = 'CookiePolicy',
    PRIVACY_POLICY = 'PrivacyPolicy',
    SET_LANGUAGE = 'LanguageSet',
    TIMEZONE = 'Timezone',
    /** Matches {@code CDocTopicsConst.sDOCTOPIC_CONFIGCHANGELOG} (Audit Trail / Config Change Log). */
    AUDIT_TRAIL = 'AuditTrail'
}
